import React, { useState, useEffect } from 'react';
import { func, string, bool, oneOfType, instanceOf, number } from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core';
import IconCheck from './icons/IconCheck';
import IconCheckboxUncheck from './icons/IconCheckboxUncheck';
import IconCheckboxChecked from './icons/IconCheckboxChecked';
import IconCheckboxIndeterminate from './icons/IconCheckboxIndeterminate';

const useStyles = makeStyles({
  checkBoxRoot: {
    padding: 12,
    '& .MuiSvgIcon-root': {
      fontSize: '22px !important',
    },
  },
});

const DECheckbox = ({
  onChange,
  id,
  isChecked = false,
  indeterminate = false,
  disabled = false,
  data = null,
}) => {
  const classes = useStyles();
  const [checked, setCheck] = useState(isChecked);

  useEffect(() => {
    setCheck(isChecked);
  }, [isChecked]);

  const _handleOnChange = () => {
    setCheck(!checked);
    onChange(!checked, data || null);
  };

  return (
    <Checkbox
      onChange={_handleOnChange}
      checked={checked}
      disabled={disabled}
      id={id}
      indeterminate={indeterminate}
      classes={{
        root: classes.checkBoxRoot,
      }}
      color="primary"
      icon={<IconCheckboxUncheck stroke={disabled ? '#cfd5dd' : '#94A2B7'} />}
      checkedIcon={<IconCheckboxChecked />}
      indeterminateIcon={<IconCheckboxIndeterminate />}
      data-test = 'CheckBox'
    />
  );
};

DECheckbox.propTypes = {
  onChange: func.isRequired,
  id: string.isRequired,
  isChecked: bool.isRequired,
  disabled: bool,
  indeterminate: bool,
  data: oneOfType([string, instanceOf(Object), number]),
};
DECheckbox.defaultProps = {
  disabled: false,
  indeterminate: false,
};

export default DECheckbox;
